<template>
  <vx-card no-shadow>
    <!-- Img Row -->
    <div class="flex flex-wrap items-center mb-4">
      <vs-avatar :src="user.photo" size="70px" class="mr-4 mb-4" />
      <vs-row>
        <label class="mr-4 sm:mb-0 mb-2 vs-button vs-button-style">
          <input type="file" id="profile-img-upload" @change="onFileSelected" />
          Profilbild hochladen
        </label>
        <vs-button
          class="mr-4"
          type="border"
          color="danger"
          @click="onDeletePhoto"
          >Löschen</vs-button
        >
        <p class="text-sm mt-2">Erlaubte Formate: JPG, GIF und PNG.</p>
      </vs-row>
    </div>

    <!-- Info -->
    <vs-input
      class="w-full mb-4"
      label="Name"
      :placeholder="user.name"
      v-model="name"
    ></vs-input>
    <vs-input
      class="w-full mb-4"
      label="Email"
      :placeholder="user.email"
      v-model="email"
    ></vs-input>
    <vs-input
      class="w-full mb-4"
      label="Telefon"
      :placeholder="user.phone"
      v-model="phone"
    ></vs-input>

    <!-- Save & Reset Button -->
    <div class="flex flex-wrap items-center justify-end">
      <vs-button class="ml-auto mt-2" @click="onUpdateProfile"
        >Speichern</vs-button
      >
    </div>

    <!-- Delete Account -->
    <div
      class="mt-8 pt-4"
      style="border-top: 1px solid rgba(255, 255, 255, 0.1)"
    >
      <p class="text-sm mb-2" style="color: #999">
        Account und alle Daten unwiderruflich löschen
      </p>
      <vs-button color="danger" type="border" @click="onDeleteAccount"
        >Account löschen</vs-button
      >
    </div>
  </vx-card>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import axios from "../../axios";

export default {
  data() {
    return {
      name: "",
      email: "",
      phone: "",
    };
  },
  computed: {
    ...mapGetters({
      user: "auth/user",
    }),
  },
  mounted() {
    this.name = this.user.name;
    this.email = this.user.email;
    this.phone = this.user.phone;
  },
  methods: {
    ...mapActions({
      fetchUser: "auth/fetchUser",
    }),
    async onUpdateProfile() {
      if (this.name !== "" || this.email !== "" || this.phone !== "") {
        try {
          let data = {
            name: this.name,
            email: this.email,
            phone: this.phone,
          };
          let response = await axios.put("/api/auth/user", data);
          if (response.data.success) {
            await this.fetchUser();
            this.$vs.notify({
              title: "Juhuu!",
              text: "Dein Profil wurde erfolgreich aktualisiert",
              color: "success",
              position: "top-center",
              icon: "done",
            });
          }
        } catch (error) {
          console.log(error);
          this.$vs.notify({
            title: "Fehler",
            text: "Dein Profil konnte nicht aktualisiert werden",
            color: "danger",
            position: "top-center",
            icon: "error",
          });
        }
      } else {
        this.$vs.notify({
          title: "Fehler",
          text: "Ändere mindestens ein Feld, um dein Profil zu aktualisieren",
          color: "danger",
          position: "top-center",
          icon: "error",
        });
      }
    },
    async onFileSelected(event) {
      try {
        this.$vs.loading({
          type: "corners",
        });
        this.selectedFile = event.target.files[0];
        this.fileName = event.target.files[0].name;
        let data = new FormData();
        data.append("photo", this.selectedFile, this.selectedFile.name);

        let response = await axios.put("/api/auth/user", data);
        this.$vs.loading.close();

        if (response.data.success) {
          await this.fetchUser();
          document.getElementById("profile-img-upload").value = "";
          this.$vs.notify({
            title: "Juhuu!",
            text: "Dein Foto wurde erfoglreich hochgeladen",
            color: "success",
            position: "top-center",
            icon: "done",
          });
        }
      } catch (error) {
        console.log(error);
        this.$vs.notify({
          title: "Fehler",
          text: "Dein Foto konnte nicht aktualisiert werden",
          color: "danger",
          position: "top-center",
          icon: "error",
        });
      }
    },
    async onDeleteAccount() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Account löschen?",
        text: "Dein Account und alle gespeicherten Daten werden unwiderruflich gelöscht. Bestellhistorie wird anonymisiert aufbewahrt.",
        acceptText: "Endgültig löschen",
        cancelText: "Abbrechen",
        accept: async () => {
          try {
            let response = await axios.delete("/api/auth/account");
            if (response.data.success) {
              this.$store.dispatch("auth/logout");
              this.$router.push("/pages/login");
              this.$vs.notify({
                title: "Account gelöscht",
                text: "Dein Account wurde erfolgreich gelöscht",
                color: "success",
                position: "top-center",
              });
            }
          } catch (error) {
            this.$vs.notify({
              title: "Fehler",
              text: "Account konnte nicht gelöscht werden",
              color: "danger",
              position: "top-center",
            });
          }
        },
      });
    },
    async onDeletePhoto() {
      try {
        let response = await axios.put("/api/auth/user", {
          deletePhoto: true,
        });

        if (response.data.success) {
          await this.fetchUser();
          this.$vs.notify({
            title: "Erfolg",
            text: "Dein Foto wurde erfoglreich gelöscht",
            color: "success",
            position: "top-center",
            icon: "done",
          });
        }
      } catch (error) {
        console.log(error);
        this.$vs.notify({
          title: "Fehler",
          text: "Dein Profil konnte nicht gelöscht werden",
          color: "danger",
          position: "top-center",
          icon: "error",
        });
      }
    },
  },
};
</script>

<style>
input[type="file"] {
  display: none;
}

.vs-button-style {
  background: rgba(var(--vs-primary), 1) !important;
}

.vs-button-style:hover {
  box-shadow: 0 0 11px rgba(33, 33, 33, 0.2);
}
</style>
